<ion-button class="kiosk-select-quantity-btn" color="white" (click)="select($event)">{{ item }}</ion-button>
